var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('center',[_c('h1',[_vm._v("About")]),_c('p',[_vm._v("This is the TodoList app v1.0.0.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }